<template>
  <el-dialog :visible.sync="innerVisible" :title="title" width="620px" :close-on-click-modal="false" @close="closeHandler">
    <check-result-display :current-state="currentState" :title="title" />
    <div v-if="dataSource.length > 0" class="single-wrap">
      <el-scrollbar>
        <check-item-renderer v-if="currentState != 'checking' && dataSource.length > 0" :data="dataSource" />
      </el-scrollbar>
    </div>
    <template v-if="!!remark">
      <el-divider />
      <div>
        {{ remark }}
      </div>
    </template>
    <div class="app-main-inner-row" style="padding: 0px;">
      <span v-show="labelRemark.visible" style="color:red; line-height: 24px;">{{ labelRemark.text }}</span>
      <span v-show="labelRemark2.visible">{{ labelRemark2.text }}</span>
    </div>

    <div v-show="areaRemark.visible">
      <el-input v-model="areaRemark.text" :disabled="!areaRemark.editable" type="textarea" :row="5" />
    </div>

    <div class="app-main-inner-row" style="padding: 0px;">
      <span v-show="labelRejectRemark.visible">{{ labelRejectRemark.text }}</span>
      <span v-show="labelRejectRemark2.visible" style="color: red;">{{ labelRejectRemark2.text }}</span>
    </div>
    <div v-show="areaRejectRemark.visible">
      <el-input v-model="areaRejectRemark.text" :disabled="!areaRejectRemark.editable" type="textarea" :row="5" />
    </div>
    <div class="split-empty-div" />
    <span slot="footer">
      <el-button v-show="btn.showConfirmButton && currentState!==states.failure && currentState!==states.checking" type="primary" @click="continueHandler">{{ btn.confirmText }}</el-button>
      <el-button v-show="btn.showCloseButton" type="danger" @click="closeHandler">{{ btn.closeText }}</el-button>
    </span>
  </el-dialog>
</template>

<script>

const states = {
  checking: 'checking',
  success: 'success',
  warning: 'warning',
  failure: 'failure'
}

import ErrorTip from '@/utils/class/ErrorTip'
import CheckResultDisplay from './CheckResultDisplay'
import CheckItemRenderer from './CheckItemRenderer'

import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'

export default {
  name: 'CheckingSaveJobWindow',
  components: { CheckResultDisplay, CheckItemRenderer },
  props: {
    visible: { type: Boolean, required: true },
    checkNode: { type: Number, required: true },
    lob: { type: String, required: true },
    rowData: { type: Array, default: () => [] },
    callBack: { type: Function, default: null },
    closeCallback: { type: Function, default: null }
  },
  data() {
    return {
      states,
      innerVisible: this.visible,
      currentState: states.checking,
      dataSource: [],
      loadings: [],
      remark: '',
      labelRemark: {
        text: '',
        visible: false
      },
      labelRemark2: {
        text: '',
        visible: false
      },
      areaRemark: {
        height: 100,
        text: '*',
        visible: false,
        editable: false
      },
      areaRejectRemark: {
        text: '',
        visible: false,
        editable: false
      },
      labelRejectRemark: {
        text: '',
        visible: false
      },
      labelRejectRemark2: {
        text: '*',
        visible: false
      },
      checkState: states.checking, // 验证状态
      showCheckResultDisplay: false,
      auditType: false, // 是否预提交审核
      title: '',
      returnValue: false, // 方法回调返回值
      btn: {
        confirmText: this.$t('CargoMsg.Cargo_ConfirmR'),
        closeText: this.$t('CargoMsg.Cargo_Close'),
        showConfirmButton: false,
        showCloseButton: false
      }

    }
  },
  errorCaptured(err) {
    if (err instanceof ErrorTip) {
      this.$message(err)
      return false
    }
    return true
  },
  computed: {
  },
  watch: {
    currentState: {
      handler(val) {
        if (val === this.states.success) {
          this.btn.confirmText = this.$t('CargoMsg.Cargo_ConfirmR')
        } else if (val === this.states.warning) {
          this.btn.confirmText = this.$t('CargoMsg.Cargo_GoOn')
        } else if (val === this.states.failure) {
          this.btn.closeText = this.$t('CargoMsg.Cargo_Close')
        } else {
          this.btn.closeText = this.$t('CargoMsg.Cargo_Cancel')
        }
      },
      immediate: true
    },
    visible: {
      handler(val) {
        this.innerVisible = val
        if (val) {
          this.addedToStageHandler()
        }
      },
      immediate: true
    }
  },
  created() {
  },
  beforeMount() {
  },
  methods: {
    async addedToStageHandler() {
      const node = CommonState.getStateByCode(CheckRuleConstants.CHECK_NODES, this.checkNode)
      this.title = this.$store.getters.language === 'zh' ? node.chineseName : node.englishName
      this.checkState = 'checking'
      this.currentState = 'checking'
      this.remark = null
      if (CheckRuleConstants.NODE_REMARK_MAPPING[this.checkNode]) { this.remark = CheckRuleConstants.NODE_REMARK_MAPPING[this.checkNode] }
      this.buttonShow2(false)
      this.areaRemark.text = ''
      this.areaRejectRemark.text = ''
      this.showCheckResultDisplay = true
      this.convertData(this.rowData || [])
    },
    buttonShow2(show) {
      this.btn.showCloseButton = !show
      this.btn.showConfirmButton = !show
    },
    buttonShow(show) {
      this.btn.showCloseButton = !show
    },
    convertData(results) {
      const dataSource = []
      this.loadings.length = 0
      this.checkState = 'success'
      this.auditType = false
      if (results && results.length > 0) {
        for (const checkRule of results) {
          if (!checkRule['match'] && checkRule['continueCheck'] && checkRule['checkMode'] === CheckRuleConstants.MODE_WARNING.code && this.checkState === 'success') { this.checkState = 'warning' }
          if (!checkRule['match'] && !checkRule['continueCheck']) { this.checkState = 'failure' }
          if (!checkRule['match'] && checkRule['checkMode'] === CheckRuleConstants.MODE_AUDIT.code &&
            !checkRule['continueCheck'] && (checkRule['checkNode'] === 1 || checkRule['checkNode'] === 2)) { this.auditType = true }
          const node = {}
          node['type'] = 'node'
          node['name'] = checkRule['ruleName']
          node['checkMode'] = checkRule['checkMode']
          node['checkCategory'] = checkRule['checkCategory']
          dataSource.push(node)

          // 子集验证项
          for (const item of checkRule['expressions']) {
            const obj = {}
            obj['type'] = 'item'
            obj['name'] = item['checkItem']
            obj['value'] = item['checkValue']
            obj['operator'] = item['operator']
            obj['match'] = item['match']
            obj['customDescription'] = item['customDescription']
            obj['checking'] = false
            obj['node'] = node
            dataSource.push(obj)
            this.loadings.push(obj)
          }
        }
        this.currentState = this.checkState
        this.dataSource = dataSource
      } else {
        this.currentState = this.checkState
        this.showCheckResultDisplay = true
      }
      if (this.checkState === 'failure' && this.auditType) {
        this.buttonShow(false)
        this.remarkShow(true)
        this.areaRemark.visible = true
        this.rejectShow()
        this.remarkEdit(true)
        this.remarkData()
      } else {
        if (this.checkState === 'success') {
          this.currentState = this.checkState
        }
        this.buttonShow2(false)
        this.labelRejectRemark.visible = this.labelRemark.visible = false
        this.labelRejectRemark2.visible = this.labelRemark2.visible = false
        this.areaRejectRemark.visible = this.areaRemark.visible = false
      }
      this.confirmButtonShow()
    },

    /**
     * 文本框高度及文字控制
     */
    remarkData() {
      if (this.areaRemark.visible) {
        this.areaRemark.height = 160
        this.areaRemark.text = this.job.manageAuditRemark
      }
      if (this.areaRejectRemark.visible && ((this.job.manageAuditRejectRemark != null && this.job.manageAuditRejectRemark !== '') || (this.checkNode === 10))) {
        this.areaRemark.height = 80
        this.areaRejectRemark.text = this.job.manageAuditRejectRemark
      }
    },
    remarkEdit(isEdit) {
      if (this.areaRemark.visible) {
        this.areaRemark.editable = isEdit
      }
      if (this.areaRejectRemark.visible) {
        this.areaRejectRemark.editable = !isEdit
      }
    },
    rejectShow() {
      this.labelRejectRemark2.visible = this.labelRejectRemark.visible = false
      this.areaRejectRemark.visible = false
    },
    confirmButtonShow() {
      if (this.btn.showConfirmButton && (this.areaRemark.visible === false)) {
        this.btn.showConfirmButton = true
      } else {
        this.btn.showConfirmButton = false
      }
    },
    closeHandler() {
      if (this.closeCallback) {
        this.closeCallback()
      }
      this.toCloseDialog()
    },
    continueHandler() {
      if (this.callBack != null) {
        this.returnValue = this.callBack()
        if (this.returnValue) {
          this.$emit('returnCallBack', this.returnValue)
        }
      }
      this.toCloseDialog()
    },
    faultHandler() {
      this.$message.warning(this.$t('Message.ThePleaseRefreshAndAgain'))
    },
    toCloseDialog() {
      // 验证规则验证业务之后需要更新业务
      this.$emit('closeCallback')
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__body{
  .single-wrap{
    border: 1px solid #EAEEF5;
    height: 310px;
    > .el-scrollbar{
      height: 310px;
      .el-scrollbar__wrap{
        overflow-x: hidden;
        .el-scrollbar__view{
          padding-bottom: 20px;
        }
      }
      .is-vertical{
        opacity: 1;
        .el-scrollbar__thumb{
          background-color: rgba(153, 153, 153, 0.8);
        }
      }
    }
  }
  .app-main-inner-row{
    line-height: 30px;
  }
  textarea{
    height: 80px;
  }
}
</style>
<style>
  .checking-window .el-dialog__body{
    padding: 0px 10px!important;
  }
</style>
